import React, { useRef } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import useDuperbrowseLink from '../../../../../Duperbrowse/hooks/useDuperbrowseLink';
import { useBiDataForDeviationLink } from '../../../../../Duperbrowse/DeviationLink/useBiDataForDeviationLink';
import Button from '../../../../../Button';
import { getDeviationUrl } from '../../../../_helpers';
import { getDeviationEntityId } from '../../../../../redux/normalizr/schemas/deviation';
import s from './PollDuperbrowseLink.scss';

interface PollDuperbrowseLinkProps {
  deviation: PapiDeviation;
  children: React.ReactNode;
}

/*
  Using our own component-specific component here instead of modifying DeviationLink
  to accept an arbitrary component due to some small if statements in DeviationLink's
  definition not playing well with the data on polls. Modifying DeviationLink will
  take more effort to assure no regressions occur than just creating this small component.
*/
const PollDuperbrowseLink: React.FC<PollDuperbrowseLinkProps> = ({
  deviation,
  children,
}) => {
  const ref = useRef<HTMLElement>(undefined);
  const linkBiData = useBiDataForDeviationLink(deviation);
  const onDuperbrowseClick = useDuperbrowseLink(
    getDeviationEntityId(deviation),
    ref
  );

  return (
    <Button
      href={getDeviationUrl(deviation)}
      view="b14"
      onClick={onDuperbrowseClick}
      className={s['button']}
      biData={linkBiData}
    >
      {children}
    </Button>
  );
};
PollDuperbrowseLink.displayName = 'PollDuperbrowseLink';

export default PollDuperbrowseLink;
